import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { IDataSerie, IDataSerieParams, IProductoFactorSeriePagingRes, IProductoFactorSerieParams, ISeriePagingRes, IStockFactorSerie, } from "@/shared/interfaces/erp/administration/productofactorserie.interface";
import { getUrlParamsFetch } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";

const { get, post } = erpApi();

///* obtener producto factor serie
export const useFetchGetProductoFactor = (params?: IProductoFactorSerieParams, enabled = true) => {
  return useQuery({
    queryKey: ['productofactorserie', ...Object.values(params ?? {})],
    queryFn: async () => {
      return getProductoFactor(params);
    },
    enabled,
  });
};

export const getProductoFactor = async (params?: IProductoFactorSerieParams) => {

  const queryParams = getUrlParamsFetch(params || {});

  return await get<IProductoFactorSeriePagingRes>(
    `${urlBackend}api/v1/productofactorserie/?${queryParams}`,
    true
  );
};

export const getStockFactorSerie = async (params?: IProductoFactorSerieParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  return await get<IStockFactorSerie>(
    `${urlBackend}api/v1/stock-factor-serie/?${queryParams}`,
    true
  );
};

///* serie

export const useFetchGetAllSeries = ({
  params, enabled
}: {
  params?: IDataSerieParams, enabled: boolean
}) => {
  return useQuery({
    queryKey: ['series', ...Object.values(params ?? {})],
    queryFn: async () => {
      return getAllSeries(params);
    },
    enabled,
  });
};


export const getAllSeries = async (params?: IDataSerieParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  return await get<ISeriePagingRes>(
    `${urlBackend}api/v1/series/?${queryParams}`,
    true
  );
};

const PAGE_SIZE = 20;

const toOptionString = (item: IDataSerie) =>
  item.serie                         // 1) prioriza codigo
  ?? item.serie                      // 2) o nombre
  ?? String(item);


export const fetchPageSeries = async (query: string, page: number, params: any) => {
  try {
    const res = await getAllSeries({
      ...params,
      serie: query,
      page,
      page_size: PAGE_SIZE,
    });
    const items = res.data.data;
    const total = res.data?.count ?? 0;

    const options: string[] = items
      .map(toOptionString)
      .filter((s: unknown): s is string => typeof s === "string")

    const hasMore = (page * PAGE_SIZE < total);

    return { options, hasMore };
  } catch (err) {
    // En caso de error, no cortes el scroll del usuario
    console.error("fetchPageSeries error:", err);
    return { options: [] as string[], hasMore: false };
  }
};

export type BuscarSerieBulkResponse = {
    series_encontradas: [
      {
        serie: string;
        metros_actuales: number;
        codigo: string;
      }
    ]
    total_encontradas: number;
    total_solicitadas: number;
  }

export const buscarSerieBulk = async (data: any) => {

  return post<BuscarSerieBulkResponse>(`${urlBackend}api/v1/series/buscar/`, data, true);
};